import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  addInboundOrder(context, payload) {
    return axios
      .post("/api/fulfillment/po_upload", payload)
      .then((res) => res.data);
  },
  getInboundOrderList(_, payload) {
    return axios
      .get(`/api/fulfillment/po_list`, {
        params: payload,
      })
      .then((res) => res);
  },
  getItemDetails(_, data) {
    return axios
      .post(
        `/api/fulfillment/po_items?page=${data.options.page}&itemsPerPage=${data.options.itemsPerPage}&sortDesc[]=${data.options.sortDesc}&mustSort=${data.options.mustSort}&&multiSort=${data.options.multiSort}`,
        {
          ...data.options,
          po_id: data.po_id,
        }
      )
      .then((res) => res);
  },
  getGrnDetails(context, payload) {
    return axios
      .post("/api/fulfillment/inbound_grns", payload)
      .then((res) => res.data);
  },
  getGrnOrderDetails(context, payload) {
    return axios
      .post("/api/fulfillment/inbound_grns_items", payload)
      .then((res) => res.data);
  },
  syncInboundOrder(context, id) {
    if (id == undefined) {
      return axios.get(`api/fulfillment/inbound_sync`).then((res) => res.data);
    } else {
      return axios
        .get(`api/fulfillment/inbound_sync?client_id=${id}`)
        .then((res) => res.data);
    }
  },
  downloadInboundOrderList(context, payload) {
    return axios
      .get(`/api/fulfillment/inbound_download`, {
        params: payload,

        responseType: "blob",
      })
      .then((res) => res);
  },
  downloadInboudOrderRow(context, id) {
    return axios
      .get(`/api/fulfillment/inbound_items_download/${id}`, {
        responseType: "blob",
      })
      .then((res) => res);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
